<template>
    <CodiceFeanorView tool-module="json" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
